import { CpuPerformanceTab } from "..";

export const cpuPerformanceScreenBody = (data: any) => {
  return (
    <>
      <CpuPerformanceTab data={data[0]} lineData={data[1]} />
    </>
  );
};
